import { render, staticRenderFns } from "./user.vue?vue&type=template&id=2b1629af&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style0 from "./user.vue?vue&type=style&index=0&id=2b1629af&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1629af",
  null
  
)

export default component.exports